import ModalPersonasImplicadas from './ModalPersonasImplicadas';

export default ModalPersonasImplicadas;
